import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "In smo opravili",
  "description": "",
  "published": "2007-06-23T00:00:00.000Z",
  "redirect_from": ["/blog/in-smo-opravili/swizec/183"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`No vÄeraj je bil zadnji dan mature zatorej zadnji dan, ko se je bilo treba vsaj pribliÅ¾no obremenjevati s Äimerkoli povezanim s srednjo šolo. Prav, še vedno je treba Äakati na rezultate, ampak to me sploh ne skrbi, ker za vstop na izbrani faks potrebujem samo, da zdelam, Äreva pa mi pravijo, da bom dobil veliko veÄ kot to, bomo videli.`}</p>
    <p>{`Medtem, `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=XngQJzAmVm8"
      }}>{`tukaj`}</a>{` je `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=4luRhIxvAX8"
      }}>{`nekaj`}</a>{` `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=WWjRzy-pTsE"
      }}>{`upoÄasnjenih`}</a>{` `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=66qZq_8eP20"
      }}>{`posnetkov`}</a>{` vodnih balonov, zelo vredno ogleda.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      